// frame: DGwHs @ ui/dogdisk-user.pen
// spec: docs/ui/user-page-flows.md §2.7 DGwHs 页面-404
//
// 公开错误页(免登录可访问)。可通过 router `/404` 跳转,也可直接以
// <NotFoundView /> 内嵌在页面组件里(参数非法 / 资源不存在场景)。

import { useNavigate } from 'react-router-dom'
import { ErrorPageView } from './_view'

export function NotFoundView({ reason }: { reason?: string } = {}) {
  return (
    <ErrorPageView
      frameId="DGwHs"
      code="404"
      title="页面未找到"
      desc="你访问的页面不存在或已被移除"
      {...(reason ? { reason } : {})}
    />
  )
}

export function NotFoundPage() {
  const navigate = useNavigate()
  // 避免 ESLint unused;route 直挂时由 main.tsx 内联使用 navigate
  void navigate
  return <NotFoundView />
}
